// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "152ccbd5" + "." + "738c1acc328e0c5e" + ".js";
};